import {convertViaDOM} from './dom'
import {convertMath} from './math'
import {convertSpelling} from './spelling'

export function processStringContent(str, options = {}) {
    if (!str) {
        return str
    }

    const {
        keep_html = true,
        convert_math = true,
        convert_spelling = true,
        country = 'US'
    } = options

    let str_new = str

    if (!keep_html) {
        str_new = str_new.replace(/(<([^>]+)>)/ig, '')
    }

    if (convert_math) {
        str_new = convertMath(str_new)
    }

    str_new = convertViaDOM(str_new, (elem) => {
        let text_new = elem.textContent

        if (convert_spelling) {
            text_new = convertSpelling(text_new, country)
        }

        elem.replaceWith(text_new)
    })

    return str_new
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getRangeArrayFromNumber(number) {
    let range = [];
    for (let i = 1; i <= number; i++) {
        range.push(undefined);
    }

    return range;
}

export function arrayIntersection(array1, array2) {
    const array1Set = new Set(array1);
    const array2Set = new Set(array2);
    const intersection = array1Set.intersection(array2Set);

    return [...intersection]
}